import { SelectionModel } from '@angular/cdk/collections';
import { HttpErrorResponse } from '@angular/common/http';
import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Inject,
    inject,
    Input,
    isDevMode,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatExpansionPanel } from '@angular/material/expansion';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { MatLegacySelect as MatSelect } from '@angular/material/legacy-select';
import {
    MatLegacyTable as MatTable,
    MatLegacyTableDataSource as MatTableDataSource,
} from '@angular/material/legacy-table';
import { Router } from '@angular/router';
import { IAppRequest } from '@app/app.interface';
import { AppService } from '@app/app.service';
import { AppHelper } from '@app/core/app.helper';
import { TokenStorage } from '@app/core/token.storage';
import { FormFilterComponent } from '@app/modules/form-filter/form-filter.component';
import { TABLE_FIXED_COLUMS } from '@app/modules/table/constants/table.constants';
import { FormFilterSavedSearchesService } from '@app/modules/table/services/form-filter-saved-searches.service';
import { FormFilterTableControlService } from '@app/modules/table/services/form-filter-table-control.service';
import { TableEventService } from '@app/modules/table/services/table-event.service';
import { TableReorderButtonsService } from '@app/modules/table/services/table-reorder-buttons.service';
import { TableService } from '@app/modules/table/table.service';
import { IOutputEventData } from '@components/buttons-panel/buttons-panel.interface';
import { AppDialogService } from '@components/dialog/services/app-dialog.service';
import { IMG_EXTENSIONS } from '@components/fields/file/constains/file-constains';
import { IPaletteRecord } from '@modules/palettes/interfaces/palettes.interface';
import { FormaterPipe } from '@pipes/formater/formater.pipe';
import { NotifierService } from '@services/notifier.service';
import { TuiDestroyService } from '@taiga-ui/cdk';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject, combineLatest, Observable, of, Subject, zip } from 'rxjs';
import { catchError, debounceTime, filter, map, take, takeUntil } from 'rxjs/operators';
import { getDateTimeRuFormat } from 'src/shared/helpers/date-helpers';
import { getSpinnerHtml } from 'src/shared/helpers/spinner-helpers';
import { stripHtml } from '../../../shared/helpers/text-helpers';
import { DesignerFilterService } from '../designer-filter/designer-filter.service';
import { FactorRowHistoryService } from '../factor-row/services/factor-row-history.service';
import { FactorRowService } from '../factor-row/services/factor-row.service';
import { FilterDialogsComponent } from './dialogs/filter-dialogs/filter-dialogs.component';
import { TreeNode } from './dialogs/settings-table/interfaces/settings.table.dialog.interface';
import { SettingsTableDialogComponent } from './dialogs/settings-table/settings.table.dialog.component';
import { TableLayerDialogComponent } from './dialogs/table-layer-dialog/table-layer-dialog.component';
import { CustomSortDirection, Sort } from './sort/custom.sort';
import { TableSkeletonService } from './table-skeleton/table-skeleton.service';
import {
    IButton,
    InterfaceSettingsTable,
    InterfaceSettingsUserColumns,
    InterfaceTableElement,
    InterfaceTableFileStruct,
    ITableCustomFilter,
} from './table.interface';
import { TableHeaderComponent } from '@app/modules/table/children/table-header/components/table-header.component';

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./styles/table.component.scss', './styles/table.component.adaptive.scss'],
    providers: [
        TableSkeletonService,
        TuiDestroyService,
        FormFilterTableControlService,
        FormFilterSavedSearchesService,
        FormaterPipe,
        TableEventService,
        TableReorderButtonsService,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
    /** Признак полноэкранного режима */
    isFullScreenMode = false;
    /** Элемент пагинации */
    @ViewChild('UsersMatPaginatorTop', { static: true }) paginatorTables;
    /** Элемент сортировки */
    @ViewChild('UsersMatSort', { static: true }) sortTables;
    @ViewChild('dataMatTable', { static: false }) dataMatTable: MatTable<any>;
    @ViewChild('globalSearchInput', { static: true })
    globalSearchInput: FormControl = new FormControl();
    @ViewChild('tableContainer', { static: false }) tableContainer: ElementRef;
    @ViewChild('tableCard', { static: false, read: ElementRef }) tableCard;
    /** Заголовок таблицы */
    @ViewChild('tableHeader', { static: false, read: ElementRef }) tableHeader: ElementRef;
    @ViewChild('tableHeader', { static: false, read: TableHeaderComponent }) tableHeaderComponent: TableHeaderComponent;
    @ViewChild('matTable', { static: false }) matTable: ElementRef;
    /** Элемент Фильтра */
    @ViewChild(FormFilterComponent, { static: false })
    appFormFilter: FormFilterComponent;
    @ViewChild('filterExpansionPanel', { static: false })
    filterExpansionPanel: MatExpansionPanel;
    /** Элемент панели таблицы (кнопки, пагинация) */
    @ViewChild('tablePanel')
    tablePanel: ElementRef;
    /**  Добавочные фильтры запроса */
    @Input() customFilter: ITableCustomFilter = {};
    /** Динамическая часть фильтра */
    @Input() dynamicFilter: any = null;
    /** Имя полей */
    @Input() dynamicFieldName: any = null;
    /** Добавление расширенного фильтра  */
    @Input() extendFilter: any = {};
    /** Локальный фильтр таблицы */
    @Input() isLocalFilter = false;

    /** Таблица оперирует с локальными данными. */
    @Input() hasLocalData = false;

    /** Измененный список колонок */
    @Input() editColumns = [];
    /**  Сервис взаимодействия страницы */
    @Input() tableService: TableService | any;

    /** Набор кнопок */
    @Input() buttons: {
        global?: IButton[];
        globalMenu?: IButton[];
        local?: IButton[];
    } = { global: [], globalMenu: [], local: [] };

    /** Добавление кнопок от настроек таблицы */
    @Input() addButtonsInTable: {
        [key: string]: {
            button: IButton;
            menu: string[];
        };
    } = {};

    @Input() showElement: boolean = false;
    //TODO: все output которые обрабатывают кнопки нужно заменить на buttonClick
    @Output() reassign = new EventEmitter<any>();
    @Output() saveCard = new EventEmitter<any>();
    @Output() add = new EventEmitter<any>();
    @Output() copy = new EventEmitter<any>();
    @Output() edit = new EventEmitter<any>();
    @Output() customDeleteArray = new EventEmitter<any>();
    @Output() send = new EventEmitter<any>();
    @Output() report = new EventEmitter<any>();
    @Output() createPrivateOffice = new EventEmitter<any>();
    @Output() changeSubject = new EventEmitter<any>();
    @Output() deleteForPeriod = new EventEmitter<any>();
    @Output() activated = new EventEmitter<any>();
    @Output() deactivated = new EventEmitter<any>();
    @Output() openDialog = new EventEmitter<any>();
    @Output() dblClickRow = new EventEmitter<any>();
    @Output() show = new EventEmitter<any>();
    @Output() export = new EventEmitter<any>();
    @Output() import = new EventEmitter<void>();
    @Output() calculatePricing = new EventEmitter<any>();
    @Output() createGeocodeGeometry = new EventEmitter<any>();
    @Output() makeCalculation = new EventEmitter<any>();
    @Output() onFieldChange = new EventEmitter<any>();
    @Output() searchDuplicates = new EventEmitter<any>();
    @Output() generateReport = new EventEmitter<any>();
    @Output() copyAndCreate = new EventEmitter<any>();
    @Output() acceptTheReport = new EventEmitter<any>();
    @Output() rejectTheReport = new EventEmitter<any>();
    @Output() viewSection = new EventEmitter<any>();
    @Output() readArray = new EventEmitter<any>();
    @Output() exportPdf = new EventEmitter<any>();
    @Output() showReport = new EventEmitter<any>();
    @Output() addOnService = new EventEmitter<void>();
    @Output() showFile = new EventEmitter<any>();
    @Output() moveMessage = new EventEmitter<any>();
    @Output() restoreMessage = new EventEmitter<any>();
    @Output() reply = new EventEmitter<any>();
    @Output() setMapLink = new EventEmitter<any>();
    @Output() linkMap = new EventEmitter<any>();
    @Output() getChangeTracking = new EventEmitter<any>();
    @Output() generateCharges = new EventEmitter<any>();
    @Output() exportChargePaymentReport = new EventEmitter<any>();
    @Output() deleteGeometry = new EventEmitter<any>();
    /* Открыть окно настроек фильтра для регламентированного очета */
    @Output() getReportFilterSettings = new EventEmitter<any>();
    @Output() addLayer = new EventEmitter<any>();
    /** Открытие диалогового окна настройки команды ОКС */
    @Output() editTeamList = new EventEmitter<any>();
    /** Переопределяем удаление в таблице */
    @Output() customDelete = new EventEmitter<any>();
    /** Отправка данных по простым нажатиям кнопки */
    @Output() buttonClick = new EventEmitter<IOutputEventData<string>>();

    /**
     * Событие, выбрасываемое при старте выполнения метода getData
     */
    @Output() dataRequested = new EventEmitter<void>();

    /**
     * Событие, выбрасываемое по завершению выполнения метода getData
     * Возвращает новые данные, полученные таблицей
     */
    @Output() dataReceived = new EventEmitter<any[]>();

    /** Настройки дерева */
    @Input() groupByTreeColumns: {
        columnParent: string;
        columnGroup: string;
        isTree: boolean;
        rootId?: string | number;
    } = {
        columnParent: null,
        columnGroup: null,
        isTree: false,
        rootId: null,
    };
    /** Настройка редактирования строк */
    @Input() settingsEditFields: {
        isEdit: boolean;
        excludeField: string;
        fields: { [key: string]: any };
    } = {
        isEdit: false,
        excludeField: null,
        fields: {},
    };

    /** Наличие фильтров для колонок */
    get isColumnFilter(): boolean {
        return this.settingsTable?.isColumnFilter === true;
    }

    /** Полные данные записей */
    filteredDataTreeAll: any[] = [];

    classTable: string = 'table-container-random-' + (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    loadSettings: boolean = false;
    /** Выбранный фильтр */
    selectFilter: any = null;
    /** Флаг первой загрузки фильтра */
    isFirstLoadFilter = true;
    /** Данные цветов по статусам */
    dataPalette: IPaletteRecord[] = null;
    /**
     * Форма поиска
     */
    form: FormGroup = this.formBuilder?.group({});
    formEdit: FormGroup = this.formBuilder?.group({});
    /**
     * Ошибки на странице
     * @type {string}
     */
    requestError = '';
    /**
     * Элемент таблицы
     * @type {MatTableDataSource<>}
     */
    dataTables = new MatTableDataSource();

    /** Полноэкранный спиннер */
    isSpinnerFullScreen = false;

    /** Имя для спиннера компонента */
    spinnerName = '';

    selection = new SelectionModel(true, []);
    /**
     * Число записей таблицы
     * @type {number}
     */
    lengthTables = 0;
    /** Ширина колонки по умолчанию */
    defaultWidth: number = 80;
    /** Минимальная ширина колонки */
    minColumnWidth: number = 45;
    /** Слушатель изменений полей ввода */
    customInput: Subject<string> = new Subject();
    /**
     * Набор количества строк для таблицы
     * @type {number[]}
     */
    pageSizeOptionsTables = [20, 50, 100, 200];
    /**  Событие выбора количества записей на странице */
    pageEvent: PageEvent;
    /** Выбор палитры по которой будут краситься строки */
    mainPalette: string = 'status_date';
    readonly #formatter: FormaterPipe = inject(FormaterPipe);
    readonly #cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
    readonly formFilter: FormFilterTableControlService = inject(FormFilterTableControlService);
    readonly tableReorderButtonsService: TableReorderButtonsService = inject(TableReorderButtonsService);
    public readonly formFilterSavedSearchesService: FormFilterSavedSearchesService =
        inject(FormFilterSavedSearchesService);
    /**
     * Сервис событий в таблице
     */
    tableEventService: TableEventService = inject(TableEventService);
    /** Метод для очистки тегов */
    protected readonly stripHtml = stripHtml;
    /** Массив кнопок таблицы */
    globalButtons$: BehaviorSubject<IButton[]> = new BehaviorSubject<IButton[]>([]);
    /** Массив кнопок глобального меню таблицы */
    globalMenuButtons$: BehaviorSubject<IButton[]> = new BehaviorSubject<IButton[]>([]);
    /** Событие нажатие клавиши shift */
    shiftKeyPressed$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    /**
     * Флаг пустого результата поиска
     */
    emptyResult$ = new BehaviorSubject<boolean>(true);
    /** Показывать/скрывать основной контент таблицы */
    showTableContent$ = new BehaviorSubject<boolean>(true);
    /** Фильтры таблицы */
    filterTable = {};
    /** Фильтры запроса */
    filterRequest = {};
    /** Набор фильтров */
    extendFilterRecordsModel = [];
    /** Флаг отображения фильтров */
    isExtendFilterShowModel = false;
    /** ИД фильтра */
    extendFilterIdModel = '';
    /** Настройки таблицы */
    settingsTable: InterfaceSettingsTable = {
        displayedColumns: ['select'],
    };

    /**
     * Принудительное отображение панели кнопок в случае наличия расширенного поиска или сохранённых поисков.
     */
    forceButtonPanel$ = new BehaviorSubject<boolean>(false);

    /**
     * Обычно показ панели кнопок регулируется наличием расширенного поиска или сохранённых поисков.
     * Но если надо, можно явно задать здесь.
     */
    #showButtonPanel$ = new BehaviorSubject<boolean>(true);
    @Input() set showButtonPanel(value: boolean) {
        this.#showButtonPanel$.next(value);
    }

    /**
     * Текущая таблица
     */
    @Input() item;
    /**
     * Текущий язык
     */
    @Input() currentLangRelationForm;
    /**
     * Показать все изменения
     */
    @Input() isChangeTracking = false;
    /**
     * Наименование модуля таблицы для сохранения пользовательских настроек
     */
    @Input() tableModule: string;
    /**  Показывать заголовок таблицы */
    @Input() showTableHeader: boolean = true;
    /**
     * Должна ли таблица занимать всю высоту экрана (как в реестрах, например)
     */
    readonly #isFullHeight$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    dynamicSystemFields: string[] = ['status_name'];
    /** Глобальный поиск */
    globalFilter = '';

    /** Флаг загрузки данных для отрисовки */
    public isLoaded$ = new BehaviorSubject<boolean>(false);

    /** Спиннер */
    readonly spinnerHtml = getSpinnerHtml();

    public readonly trackByUserColumnsName = (column) => column.title;

    public set isFullHeight(val) {
        this.#isFullHeight$.next(val);
    }

    public get isFullHeight$() {
        return this.#isFullHeight$.asObservable();
    }

    constructor(
        @Inject(TuiDestroyService) protected _destroy$: TuiDestroyService,
        public router: Router,
        private formBuilder: FormBuilder,
        public notifier: NotifierService,
        public dialog: MatDialog,
        public spinner: NgxSpinnerService,
        public appService: AppService,
        public filterService: DesignerFilterService,
        private dialogConfirm: AppDialogService,
        private token: TokenStorage,
        public factorRowHistoryService: FactorRowHistoryService,
        public factorRowService: FactorRowService,
        public tableSkeleton: TableSkeletonService,
    ) {
        this.spinnerName = AppHelper.randomInteger(1, 999999).toString();
    }

    ngOnChanges(changes: SimpleChanges) {
        this.isSpinnerFullScreen = this.formFilter.isFilter && this.selectFilter;
        if (this.editColumns.length > 0) {
            this.settingsTable.displayedColumns = this.editColumns;
        }
        for (const propName in changes) {
            if (changes.hasOwnProperty(propName)) {
                if (propName === 'tableService' && changes[propName].previousValue !== undefined) {
                    this.ngAfterViewInit();
                }
                if (propName === 'buttons') {
                    this.adjustButtons();
                }
            }
        }
    }

    /**
     * Вызов родительской функции
     * @param type тип
     * @param value значение
     * @param event событие нажатия
     */
    callParent(type, value, event) {
        this.appService.openNewTab = event.ctrlKey || event.metaKey;
        switch (type) {
            case 'add':
                this.add.next(value);
                break;
            case 'send':
                this.send.next(value);
                break;
            case 'report':
                this.report.next(value);
                break;
            case 'edit':
                this.saveScrollTable();
                this.edit.next(value);
                break;
            case 'deleteArray':
                this.removeRecords(value);
                break;
            case 'calculatePricing':
                this.calculatePricing.next(value);
                break;
            case 'createGeocodeGeometry':
                this.createGeocodeGeometry.next(value);
                break;
            case 'makeCalculation':
                this.makeCalculation.next(value);
                break;
            case 'changeSubject':
                this.changeSubject.next(value);
                break;
            case 'deleteForPeriod':
                this.deleteForPeriod.next(value);
                break;
            case 'activated':
                this.activated.next(value);
                break;
            case 'deactivated':
                this.deactivated.next(value);
                break;
            case 'customDeleteArray':
                this.customDeleteArray.next(value);
                break;
            case 'openDialog':
                this.openDialog.next(value);
                break;
            case 'searchDuplicates':
                this.searchDuplicates.next(value);
                break;
            case 'generateReport':
                const settings = {
                    rows: this.settingsTable.userSize,
                    page: this.settingsTable.userIndex,
                    sort: this.getSortParam(this.settingsTable.userSort),
                    global_filter: this.globalFilter,
                    custom_filter: this.customFilter,
                    extended_filter: this.extendFilter,
                    filter: this.filterRequest,
                    settings: this.settingsTable,
                    value,
                };
                this.generateReport.next(settings);
                break;
            case 'dblClickRow':
                this.saveScrollTable();
                this.dblClickRow.next(value);
                break;
            case 'show':
                this.saveScrollTable();
                this.show.next(value);
                break;
            case 'createPrivateOffice':
                this.createPrivateOffice.next(value);
                break;
            case 'export':
                const data = {
                    rows: this.settingsTable.userSize,
                    page: this.settingsTable.userIndex,
                    sort: this.getSortParam(this.settingsTable.userSort),
                    global_filter: this.globalFilter,
                    custom_filter: this.customFilter,
                    extended_filter: this.extendFilter,
                    filter: this.filterRequest,
                    settings: this.settingsTable,
                };
                this.export.next(data);
                break;
            case 'import':
                this.import.next();
                break;
            case 'addOnService':
                this.addOnService.next();
                break;
            case 'showFile':
                this.showFile.next(value);
                break;
            case 'copyAndCreate':
                this.copyAndCreate.next(value);
                break;
            case 'acceptTheReport':
                this.acceptTheReport.next(value);
                break;
            case 'rejectTheReport':
                this.rejectTheReport.next(value);
                break;
            case 'viewSection':
                this.viewSection.next(value);
                break;
            case 'readArray':
                this.readArray.next(value);
                break;
            case 'exportPdf':
                this.exportPdf.next(value);
                break;
            case 'showReport':
                this.showReport.next(value);
                break;
            case 'moveMessage':
                this.moveMessage.next(value);
                this.getData(false);
                break;
            case 'restoreMessage':
                this.restoreMessage.next(value);
                this.getData(false);
                break;
            case 'reply':
                this.reply.next(value);
                break;
            case 'setMapLink':
                this.setMapLink.next(value);
                break;
            case 'linkMap':
                this.linkMap.next(value);
                break;
            case 'addLayer':
                this.addLayer.next(value);
                break;
            case 'getChangeTracking':
                this.getChangeTracking.next(value);
                break;
            case 'generateCharges':
                this.generateCharges.next(value);
                break;
            case 'exportChargePaymentReport':
                this.exportChargePaymentReport.next(value);
                break;
            case 'deleteGeometry':
                this.deleteGeometry.next(value);
                break;
            case 'getReportFilterSettings':
                this.getReportFilterSettings.next(value);
                break;
            case 'reassign':
                this.reassign.next(value);
                break;
            case 'editTeamList':
                this.editTeamList.next(value);
                break;
            case 'customDelete':
                this.customDelete.next(value);
                break;
            case 'copy':
                this.copy.next(value);
                break;
            case 'goConstructor':
                this.appService.openFactorSettings();
                break;
            case 'fullScreenMode':
                if (this.isFullScreenMode) {
                    this.#turnFullScreenOff();
                } else {
                    // Полноэкранные режим
                    this.isFullScreenMode = true;
                    this.appService.showSideMenu.next(false);
                    this.notifier.notify('success', this.appService.language_dictionary.full_screen_mode_on);
                    this.adjustButtons();
                }
                this.broadcastButtonChanges();
                break;
            default:
                this.buttonClick.next({ name: type, data: value });
        }
    }

    /**
     * Сохранение скролла таблицы
     */
    saveScrollTable(clear: boolean = false) {
        let scroll = 0;
        if (!clear && document.querySelector('.mat-table-container')) {
            scroll = document.querySelector('.mat-table-container').scrollTop;
        }
        this.token.saveScrollTable(this.getTableKey('ScrollTable'), scroll);
    }

    /**
     * Событие окончания инициализации компонента
     */
    ngOnInit() {
        if (this.tableService) {
            this.tableSkeleton.show();
        }
        if (this.isLocalFilter) {
            this.extendFilterRecordsModel = [];
            this.isExtendFilterShowModel = false;
            this.extendFilterIdModel = '';
        } else {
            // Удаляем доступные фильтры из заголовка приложения
            this.formFilter.clear();

            this.formFilter.savedSerchesService.selectedFilterId$
                .pipe(
                    filter((id) => !!id),
                    takeUntil(this._destroy$),
                )
                .subscribe((id) => {
                    this.setActiveFilter(id);
                });
        }
        const debounceInterval = this.hasLocalData ? 100 : 1000;
        this.customInput
            .pipe(debounceTime(debounceInterval), takeUntil(this._destroy$))
            .subscribe(() => this.changeFilter());

        // Принудительное отображение панели кнопок в случае наличия расширенного поиска или сохранённых поисков.
        combineLatest([
            this.#showButtonPanel$,
            this.formFilter.isFilter$,
            this.formFilterSavedSearchesService.filterRecordsLength$,
        ])
            .pipe(takeUntil(this._destroy$))
            .subscribe(([showButtonPanel, isFilter, filterRecordsLength]) => {
                this.forceButtonPanel$.next(showButtonPanel && (isFilter || filterRecordsLength > 0));
            });
    }

    /**
     * Разрушение компонента
     */
    ngOnDestroy() {
        if (this.isLocalFilter) {
            this.extendFilterRecordsModel = [];
            this.isExtendFilterShowModel = false;
            this.extendFilterIdModel = '';
        } else {
            this.formFilter.clear();
        }
        this.buttonClick.complete();
        this.appService.showSideMenu.next(true);
    }

    /**
     * Событие после завершения инициализации вьюшки
     */
    ngAfterViewInit(): void {
        this.broadcastButtonChanges();
        let localFilter = null;
        this.loadSettings = false;
        let settingData = Object.assign({}, this.customFilter);
        if (this.dynamicFilter) {
            settingData = Object.assign(settingData, this.dynamicFilter);
        }
        if (this.tableModule) {
            settingData.module = this.tableModule;
        }
        this.spinner.show(this.spinnerName);

        const request: Observable<{ type: string; result: IAppRequest }>[] = [
            this.tableService.getTableSettings(settingData).pipe(
                map((result: IAppRequest) => ({
                    type: 'settings',
                    result,
                })),
            ),
        ];

        if (this.tableService.getFiltersList) {
            request.push(
                this.tableService.getFiltersList(this?.dynamicFilter ?? {}).pipe(
                    catchError(() => of(null)),
                    map((result: IAppRequest) => ({
                        type: 'filter',
                        result,
                    })),
                ),
            );
            localFilter = this.token.getFilterTable(this.getTableKey('FilterTable'));
        } else {
            // Удаляем доступные фильтры из заголовка приложения
            this.formFilter.savedSerchesService.filterRecords = [];
            this.formFilter.isFilter = false;
        }

        zip(request)
            .pipe(take(1), takeUntil(this._destroy$))
            .subscribe({
                next: (result: { type: string; result: IAppRequest }[]) => {
                    if (!result) {
                        throw Error('Invalid server response');
                    }

                    /** Данные фильтров */
                    const filterData = result.find((row) => row.type === 'filter')?.result;
                    /** Данные настроек таблицы */
                    const settingsData = result.find((row) => row.type === 'settings')?.result;

                    let isFilter = false;

                    if (filterData && filterData.is_error === false && filterData?.data.length) {
                        isFilter = true;
                        if (this.isLocalFilter) {
                            this.extendFilterRecordsModel = filterData.data;
                            this.formFilter.isFilter = Boolean(filterData.data?.length);
                        } else if (Array.isArray(filterData.data)) {
                            this.formFilter.savedSerchesService.filterRecords = filterData.data;
                            this.formFilter.isFilter = Boolean(
                                this.formFilter.savedSerchesService.filterRecords?.length,
                            );
                        }
                    }

                    if (!settingsData || settingsData.is_error === true) {
                        throw new Error(settingsData.message);
                    }

                    this.settingsTable = Object.assign(this.settingsTable, settingsData.data);

                    /* Добавление кнопок в меню таблицы (во все 3) */
                    this.adjustButtons();

                    if (!this.settingsTable.displayedColumns) {
                        this.settingsTable.displayedColumns = [];
                    }

                    /* Установка данных для палитры */
                    this.setPaletteData(settingsData.data.palette);
                    this.settingsTable.displayedColumns = this.#sortDisplayedColumns(
                        this.settingsTable.displayedColumns,
                    );
                    if (!this.settingsTable.userColumns) {
                        this.setFirstConfig();
                    } else {
                        this.setAllColumns();
                    }
                    this.clearDisplayedColumns();
                    this.setCellForColumns();
                    this.dataTables.paginator = this.paginatorTables;
                    this.dataTables.sort = this.sortTables;
                    this.#setDefaultSort();
                    if (this.isLocalFilter) {
                        if (this.settingsTable && this.settingsTable.filterId) {
                            this.extendFilterIdModel = this.settingsTable.filterId;
                            this.setActiveFilter(this.extendFilterIdModel);
                        } else if (filterData && filterData?.data && filterData.data.length) {
                            this.extendFilterIdModel = filterData.data[0].id;
                            this.setActiveFilter(this.extendFilterIdModel);
                        }
                        if (
                            this.extendFilterRecordsModel &&
                            this.extendFilterRecordsModel.length &&
                            !this.selectFilter
                        ) {
                            this.extendFilterRecordsModel.forEach((record) => {
                                if (record.id == this.extendFilterIdModel) {
                                    this.selectFilter = Object.assign({}, record);
                                }
                            });
                        }
                    } else {
                        if (this.formFilter.savedSerchesService.filterRecordsLength) {
                            let isFilterId = false;
                            this.formFilter.savedSerchesService.filterRecords$.pipe(take(1)).subscribe((list) => {
                                list.forEach((value) => {
                                    if (value.id == this.settingsTable.filterId) {
                                        isFilterId = true;
                                    }
                                });
                                if (!isFilterId) {
                                    this.settingsTable.filterId = null;
                                }
                            });
                        } else {
                            this.settingsTable.filterId = null;
                        }
                        if (this.settingsTable && isFilter && this.settingsTable.filterId) {
                            this.formFilter.savedSerchesService.selectedFilterId = this.settingsTable.filterId;
                        } else if (filterData && filterData.data && filterData.data.length) {
                            this.formFilter.savedSerchesService.selectedFilterId = filterData.data[0].id;
                        }
                        if (this.formFilter.savedSerchesService.filterRecords.length && !this.selectFilter) {
                            const index = this.formFilter.savedSerchesService.filterRecords.findIndex(
                                (record) => record.id == this.formFilter.savedSerchesService.selectedFilterId,
                            );
                            if (index > -1) {
                                this.selectFilter = Object.assign(
                                    {},
                                    this.formFilter.savedSerchesService.filterRecords[index],
                                );
                            }
                        }
                    }
                    if (
                        ((!this.settingsTable.filterId || Number(this.settingsTable.filterId) === -1) &&
                            !localFilter &&
                            !(this.selectFilter && this.selectFilter.query)) ||
                        !this.tableService.getFiltersList
                    ) {
                        this.getData(this.tableService.isSearch);
                    }
                    this.broadcastButtonChanges();
                    this.loadSettings = true;
                },
                error: (error: HttpErrorResponse) => {
                    if (isDevMode()) {
                        console.error(error);
                    }

                    let message = this.appService.language_dictionary.system_no_connection_with_system;

                    if (error.error?.message) {
                        message = error.error?.message;
                    }

                    this.spinner.hide(this.spinnerName);
                    this.isLoaded$.next(true);
                    this.showTableHeader = false;
                    this.requestError = message;
                    this.tableSkeleton.hide();
                    this.#cdr.detectChanges();
                },
            });

        // Подписка на изменение выделения строк
        this.selection.changed.pipe(takeUntil(this._destroy$)).subscribe(() => {
            this.buttons = this.tableReorderButtonsService.reorderButtons(this.buttons, this.selection.selected.length);
            this.broadcastButtonChanges();
        });
        this.selectionKeyboardHandler();
    }

    /**
     * При инициализации и каждый раз, когда список кнопок задаётся извне,
     * нам нужно дополнить его дополнительными кнопками из addButtonsInTable
     * согласно настройкам доступности кнопок из settingsTable
     */
    private adjustButtons() {
        const buttonList = Object.keys(this.addButtonsInTable);
        if (buttonList?.length) {
            buttonList.forEach((keyButton) => {
                if (this.settingsTable?.buttons && this.settingsTable?.buttons[keyButton]) {
                    const buttonToAdd = this.addButtonsInTable[keyButton];
                    if (buttonToAdd.button.click === 'fullScreenMode') {
                        if (this.isFullScreenMode) {
                            buttonToAdd.button.color = 'soft';
                        } else {
                            buttonToAdd.button.color = 'flat';
                        }
                    }
                    buttonToAdd.menu.forEach((menuButton) => {
                        if (this.buttons[menuButton].findIndex((x) => x.name === buttonToAdd.button.name) === -1) {
                            this.buttons[menuButton].push(buttonToAdd.button);
                        }
                    });
                }
            });
        }

        [this.buttons.globalMenu].forEach((arr) => {
            arr.sort((a, b) => {
                const isDelA = a?.icon.indexOf('delete');
                const isDelB = b?.icon.indexOf('delete');
                return isDelA >= isDelB ? 1 : -1;
            });
        });

        this.broadcastButtonChanges();
    }

    /**
     * Оповестить слушателей об изменении текущего набора кнопок
     */
    private broadcastButtonChanges() {
        this.globalButtons$.next(this.buttons?.global ?? []);
        this.globalMenuButtons$.next(this.buttons?.globalMenu ?? []);
    }

    /**
     * Установка данных для палитры
     */
    setPaletteData(data: any) {
        const paletteData: IPaletteRecord[] = typeof data === 'object' ? Object.values(data) : [];
        if (!paletteData.length) {
            return;
        }

        this.dataPalette = [];
        paletteData.forEach((palette) => {
            const hasData = !palette.merged && palette.data && palette.data.length;
            const hasMergedData = palette.merged && palette.merged_data && palette.merged_data.length;
            if (hasData || hasMergedData) {
                this.dataPalette.push(palette);
                const paletteColumn = 'system_color_' + palette.index;

                // Проверяем, существует ли уже такой столбец
                if (this.settingsTable.displayedColumns.includes(paletteColumn)) {
                    // Если столбец уже существует, пропускаем его добавление
                    return;
                }

                const paletteIndex = this.dataPalette.indexOf(palette);
                if (this.settingsTable.displayedColumns[paletteIndex] !== paletteColumn) {
                    this.settingsTable.displayedColumns.splice(paletteIndex + 1, 0, paletteColumn);
                }
            }
        });
        /* Установка палитры, по которой будет происходить покраска */
        this.getMainPalette(this.dataPalette);
    }

    /**
     * Получение ключа для хранения данных
     * @param stringKey определяющая часть ключа
     */
    getTableKey(stringKey: string) {
        let key = this.tableService?.className + stringKey;
        if (this.dynamicFilter && this.dynamicFilter.factor_id) {
            key += this.dynamicFilter.factor_id;
        }
        if (this.dynamicFilter && this.dynamicFilter.relation_id) {
            key += this.dynamicFilter.relation_id;
        }
        return key;
    }

    /**
     * Изменение значения в поле
     * @param event событие
     */
    inputValueChanged(event) {
        this.customInput.next(event);
    }

    /**
     * Проставление первичных данных
     */
    setFirstConfig() {
        const adminColumns = {};
        if (this.settingsTable.adminColumns && this.settingsTable.adminColumns.length) {
            this.settingsTable.adminColumns.forEach((column) => {
                adminColumns[
                    this.dynamicFilter ? column.id + '_' + (column.relation_id ? column.relation_id : '') : column.name
                ] = column;
            });
        }
        this.settingsTable.userIndex = 1;
        this.settingsTable.userSize = 50;
        this.settingsTable.userColumns = [];
        this.settingsTable.userTree = {
            select: [],
            all: [],
        };
        this.settingsTable.allColumns.forEach((allColumn) => {
            const node = { name: allColumn.entity, level: 1, children: [] };
            allColumn.columns.forEach((column, index) => {
                node.children.push({
                    parent: allColumn.entity,
                    name: column.title,
                    alias: column.name,
                    type: column.type,
                    is_sticky: false,
                    is_main: false,
                    is_fixed: column.is_fixed,
                    width: column.width,
                    columns: [],
                    level: 2,
                    transformParam: column?.transformParam,
                });
                if (this.dynamicFilter) {
                    node.children[node.children.length - 1].id = column.id;
                    if (column.relation_id) {
                        node.children[node.children.length - 1].relation_id = column.relation_id;
                    }
                }
                if (this.settingsTable.adminColumns && this.settingsTable.adminColumns.length) {
                    if (
                        adminColumns[
                            this.dynamicFilter
                                ? column.id + '_' + (column.relation_id ? column.relation_id : '')
                                : column.name
                        ]
                    ) {
                        node.children.splice(node.children.length - 1, 1);
                        adminColumns[
                            this.dynamicFilter
                                ? column.id + '_' + (column.relation_id ? column.relation_id : '')
                                : column.name
                        ].entity = allColumn.entity;
                        adminColumns[
                            this.dynamicFilter
                                ? column.id + '_' + (column.relation_id ? column.relation_id : '')
                                : column.name
                        ].is_main = allColumn.is_main && index == 0;
                    }
                } else if (allColumn.is_main && index < 5) {
                    node.children.splice(node.children.length - 1, 1);
                    this.addDefaultColumn(allColumn.entity, column, index == 0);
                }
            });
            this.settingsTable.userTree.all.push(Object.assign({}, node));
        });
        if (this.settingsTable.adminColumns && this.settingsTable.adminColumns.length) {
            this.settingsTable.adminColumns.forEach((column) => {
                this.addAdminColumn(
                    adminColumns[
                        this.dynamicFilter
                            ? column.id + '_' + (column.relation_id ? column.relation_id : '')
                            : column.name
                    ].entity,
                    column,
                    adminColumns[
                        this.dynamicFilter
                            ? column.id + '_' + (column.relation_id ? column.relation_id : '')
                            : column.name
                    ].is_main,
                );
            });
        }
        if (!this.settingsTable.userSort) {
            if (this.settingsTable.userColumns?.length) {
                let sort = null;
                if (this.settingsTable.userColumns && this.settingsTable.userColumns?.length) {
                    sort = [
                        {
                            name: this.settingsTable.userColumns[0].name,
                            sort: 'asc',
                        },
                    ];
                }
                if (sort !== null) {
                    this.settingsTable.userSort = sort;
                }
            }
        }
    }

    /**
     * Добавление колонки из админских настроек
     * @param entity сущность
     * @param column колонка
     * @param is_main колонка главной сущности
     */
    addAdminColumn(entity: string, column: InterfaceSettingsUserColumns, is_main: boolean) {
        this.settingsTable.userColumns.push(Object.assign({}, column));
        this.settingsTable.userTree.select.push({
            parent: entity,
            id: column.id as string,
            name: column.title,
            alias: column.name,
            type: column.type,
            is_sticky: column.is_sticky,
            is_main: false,
            width: column.width,
            columns: [],
            level: 1,
        });
        if (column.is_fixed) {
            this.settingsTable.userTree.select[this.settingsTable.userTree.select.length - 1].is_fixed =
                column.is_fixed;
        }
        if (typeof column.relation_id != 'undefined') {
            this.settingsTable.userTree.select[this.settingsTable.userTree.select.length - 1].relation_id =
                column.relation_id;
        }
        this.settingsTable.displayedColumns.push(column.name);
    }

    /**
     * Добавление колонки по умолчанию
     * @param entity сущность
     * @param column колонка
     * @param is_main колонка главной сущности
     */
    addDefaultColumn(entity: string, column: InterfaceSettingsUserColumns, is_main: boolean) {
        this.settingsTable.userColumns.push({
            name: column.name,
            title: column.title,
            type: column.type,
            is_sticky: false,
            is_main,
            is_group: false,
            width: !!column.width ? column.width : this.defaultWidth,
            is_fixed: !!column.is_fixed ? column.is_fixed : false,
            transformParam: column?.transformParam,
        });
        if (column.type === 'boolean') {
            this.filterTable[column.name] = '';
        }
        this.settingsTable.userTree.select.push({
            id: column.id as string,
            parent: entity,
            name: column.title,
            alias: column.name,
            type: column.type,
            is_sticky: false,
            is_main: false,
            is_fixed: false,
            width: this.defaultWidth,
            columns: [],
            level: 1,
            transformParam: column?.transformParam,
        });
        if (this.dynamicFilter) {
            this.settingsTable.userColumns[this.settingsTable.userColumns.length - 1].id = column.id;
            this.settingsTable.userTree.select[this.settingsTable.userTree.select.length - 1].id = column.id as string;
            this.settingsTable.userColumns[this.settingsTable.userColumns.length - 1].name = column.name;
            this.settingsTable.userTree.select[this.settingsTable.userTree.select.length - 1].alias = column.name;
            if (column.relation_id) {
                this.settingsTable.userColumns[this.settingsTable.userColumns.length - 1].relation_id =
                    column.relation_id;
                this.settingsTable.userTree.select[this.settingsTable.userTree.select.length - 1].relation_id =
                    column.relation_id;
            }
        }
        if (this.dynamicFilter) {
            this.settingsTable.displayedColumns.push(
                this.settingsTable.userColumns[this.settingsTable.userColumns.length - 1].name,
            );
        } else {
            this.settingsTable.displayedColumns.push(column.name);
        }
    }

    /**
     * Очистка колонок
     * Удаляет столбец buttons, если он приходит из БД.
     */
    clearDisplayedColumns() {
        const index = this.settingsTable.displayedColumns.indexOf('buttons');
        if (index !== -1) {
            this.settingsTable.displayedColumns.splice(index, 1);
        }
    }

    /**
     * Проставление всех колонок
     */
    setAllColumns() {
        const selected = {};
        this.settingsTable.userTree.select.forEach((node) => {
            if (this.dynamicFilter) {
                selected[node.id + '_' + (node.relation_id ? node.relation_id : '')] = true;
                if (node.columns && node.columns.length) {
                    node.columns.forEach((child) => {
                        selected[child.id + '_' + (child.relation_id ? child.relation_id : '')] = true;
                    });
                }
            } else {
                selected[node.alias] = true;
                if (node.columns && node.columns.length) {
                    node.columns.forEach((child) => {
                        selected[child.alias] = true;
                    });
                }
            }
        });
        this.settingsTable.userTree.all = [];
        this.settingsTable.allColumns.forEach((allColumn) => {
            const node = { name: allColumn.entity, level: 1, children: [] };
            allColumn.columns.forEach((column) => {
                if (this.dynamicFilter) {
                    if (!selected[column.id + '_' + (column.relation_id ? column.relation_id : '')]) {
                        node.children.push({
                            parent: allColumn.entity,
                            name: column.title,
                            alias: column.name,
                            type: column.type,
                            is_sticky: false,
                            is_main: false,
                            width: this.defaultWidth,
                            is_fixed: false,
                            columns: [],
                            level: 2,
                            transformParam: column?.transformParam,
                        });
                        node.children[node.children.length - 1].id = column.id;
                        if (column.relation_id) {
                            node.children[node.children.length - 1].relation_id = column.relation_id;
                        }
                    }
                } else {
                    if (!selected[column.name]) {
                        node.children.push({
                            parent: allColumn.entity,
                            name: column.title,
                            alias: column.name,
                            type: column.type,
                            is_sticky: false,
                            is_main: false,
                            width: this.defaultWidth,
                            is_fixed: false,
                            columns: [],
                            level: 2,
                            transformParam: column?.transformParam,
                        });
                    }
                }
            });
            this.settingsTable.userTree.all.push(Object.assign({}, node));
        });
    }

    /**
     * Получение данных таблицы
     * @param isPage флаг изменения страницы
     * TODO: было бы круто этот метод вызывать снаружи и подписываться на его завершение
     */
    getData(isPage: boolean): void {
        this.isSpinnerFullScreen = this.formFilter.isFilter && this.selectFilter;
        this.requestError = '';
        if (!isPage) {
            this.settingsTable.userIndex = 1;
        }

        const data = {
            rows: this.settingsTable.userSize,
            page: this.settingsTable.userIndex,
            sort: this.getSortParam(this.settingsTable.userSort),
            global_filter: this.globalFilter,
            custom_filter: this.customFilter,
            extended_filter: this.extendFilter,
            filter: this.filterRequest,
            module: this.tableModule,
        };
        this.spinner.show(this.spinnerName);
        this.tableSkeleton.show();
        this.dataRequested.emit();

        this.tableService
            .getLists(data)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
                next: (result) => {
                    if (!this.isLoaded$.value) {
                        this.isLoaded$.next(true);
                        setTimeout(() => {
                            this.setAutoWidth();
                            this.isSpinnerFullScreen = false;
                        }, 0);
                    }
                    this.spinner.hide(this.spinnerName);
                    this.tableSkeleton.hide();
                    this.dataReceived.emit(result?.data?.rows ?? []);
                    setTimeout(() => {
                        this.increaseCount();
                    });

                    if (!result || result?.is_error === true) {
                        throw new Error(result?.message);
                    }

                    this.viewDataTable(result.data);
                    setTimeout(() => {
                        this.setAutoWidth();
                    }, 0);
                    if (this.formFilter?.isFilter) {
                        this.formFilter.recordsFound = result.data?.records;
                    }
                    this.detectChanges();
                },
                error: (error: Error) => {
                    if (isDevMode()) {
                        console.error(error);
                    }

                    if (!this.isLoaded$.value) {
                        this.isLoaded$.next(true);
                        setTimeout(() => {
                            this.setAutoWidth();
                        }, 0);
                    }

                    this.spinner.hide(this.spinnerName);
                    this.tableSkeleton.hide();
                    this.isLoaded$.next(true);
                    this.dataReceived.emit([]);
                    this.isSpinnerFullScreen = false;

                    this.requestError = error?.message;
                    if (isDevMode()) {
                        console.error(this.requestError);
                    }
                    setTimeout(() => {
                        this.increaseCount();
                    });
                    this.detectChanges();
                },
            });
    }

    /**
     * Отображение данных таблицы
     * @param data данные запроса
     */
    viewDataTable(data: any) {
        this.dataTables.filteredData = data.rows;

        // Отображение древовидной структуры
        if (this.groupByTreeColumns.isTree) {
            this.groupByTree();
        }

        if (this.settingsEditFields?.isEdit) {
            this.initFormEdit();
        }
        this.emptyResult$.next(this.dataTables.filteredData.length <= 0);
        this.lengthTables = parseInt(data.records, 10);
        this.dataTables._updatePaginator(this.lengthTables);
        this.selection.clear();
        setTimeout(() => {
            if (this.dataMatTable) {
                this.dataMatTable.updateStickyColumnStyles();
            }

            const scroll = this.token.getScrollTable(this.getTableKey('ScrollTable'));
            if (scroll && document.querySelector('.mat-table-container')) {
                document.querySelector('.mat-table-container').scroll(0, scroll);
            }
        }, 0);
    }

    /** Проставление расширенного фильтра */
    setExtendFilter() {
        if (this.form && this.form?.valid) {
            this.extendFilter = this.form.value;
            this.saveScrollTable(true);
            this.getData(false);
            this.token.saveFilterTable(this.getTableKey('FilterTable'), this.extendFilter);
            this.appFormFilter?.isFormData(true);

            if (this.appFormFilter.isSubForm()) {
                this.formFilter.isFilterSet = true;
            }
            this.formFilter.isOpenFilter = false;
        } else if (!this.form) {
            this.formFilter.isFilterSet = false;
            this.saveScrollTable(true);
            this.getData(false);
        }
    }

    /** Очистка расширенного фильтра */
    clearExtendFilter(loadTable = true) {
        this.form.reset();
        this.extendFilter = {};

        this.saveScrollTable(true);

        if (loadTable) {
            this.getData(false);
        }

        this.token.saveFilterTable(this.getTableKey('FilterTable'), this.extendFilter);
        this.appFormFilter.isFormData();

        this.formFilter.isFilterSet = false;
        this.formFilter.isOpenFilter = false;
    }

    /**
     * Очистка полей расширенного фильтра
     */
    resetExtendFilter() {
        this.form.reset();
    }

    /**
     * Изменение пагинации
     * @param event событие пагинации
     */
    onPaginateChange(event?: PageEvent): PageEvent {
        this.settingsTable.userIndex = event.pageIndex;
        this.settingsTable.userSize = event.pageSize;
        this.saveScrollTable(true);
        if (this.tableService) {
            let settingData = Object.assign({}, this.settingsTable);
            if (this.dynamicFilter) {
                settingData = Object.assign(settingData, this.dynamicFilter);
            }
            if (this.tableModule) {
                settingData.module = this.tableModule;
            }
            this.tableService.saveTableSettings(settingData).toPromise();
        }
        this.getData(true);
        return event;
    }

    /**
     * Обработка события сортировки
     * @param event событие сортировки
     */
    sortData(event: Sort[]): void {
        let sortFieldType: string;
        this.settingsTable.userSort = [];
        event.forEach((active) => {
            this.settingsTable.userColumns.forEach((elem) => {
                if (active.active == elem.name) {
                    sortFieldType = elem.type;
                    return;
                }
            });
            this.settingsTable.userSort.push({
                name: active.active,
                type: sortFieldType,
                sort: active.direction,
            });
        });
        if (this.tableService) {
            let settingData = Object.assign({}, this.settingsTable);
            if (this.dynamicFilter) {
                settingData = Object.assign(settingData, this.dynamicFilter);
            }
            if (this.tableModule) {
                settingData.module = this.tableModule;
            }
            this.tableService.saveTableSettings(settingData).toPromise();
        }
        this.saveScrollTable(true);
        this.getData(true);
    }

    /**
     * Применение фильтра
     */
    changeFilter() {
        let value;
        let name;
        this.filterRequest = {};
        Object.keys(this.filterTable).forEach((key) => {
            if (this.filterTable[key] === '') {
                return;
            }
            this.settingsTable.userTree.select.forEach((node) => {
                if (key === this.getAliasColumn(node)) {
                    value = this.filterTable[key];
                    if (typeof this.filterTable[key] === 'object' && this.filterTable[key]?.isValid()) {
                        value = this.filterTable[key].format('YYYY-MM-DD HH:mm:ss');
                    }
                    if (node.columns.length === 0) {
                        this.filterRequest[key] = typeof value === 'string' ? value.trim() : value;
                    } else {
                        name = [];
                        node.columns.forEach((alias) => name.push(alias.alias));
                        this.filterRequest[name.join('|')] = typeof value === 'string' ? value.trim() : value;
                    }
                }
            });
        });
        this.saveScrollTable(true);
        this.getData(false);
    }

    /**
     * Соответствует ли количество выбранных элементов общему количеству строк.
     */
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataTables.filteredData.length;
        return numSelected === numRows;
    }

    /**
     * Выбирает все строки, если они не все выделены; в противном случае снимает выбор.
     */
    masterToggle() {
        this.isAllSelected()
            ? this.selection.clear()
            : this.dataTables.filteredData.forEach((row) => this.selection.select(row));
    }

    /**
     * Формирует aria-label для чекбокса
     * @param row строка
     */
    checkboxLabel(row?: any): string {
        if (!row) {
            return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
        }
        return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
    }

    /**
     * Растягивание колонок таблицы по всей ширине
     */
    setAutoWidth() {
        const tableElement = document.getElementsByClassName(this.classTable);
        let table;
        if (tableElement && tableElement[0]) {
            table = tableElement[0];
        } else {
            table = document;
        }
        const tableContainer = table.querySelectorAll('.mat-table-container-table')[0] as HTMLDivElement;
        const tableDiv = table.querySelectorAll('.mat-table-container-table .mat-table')[0] as HTMLDivElement;
        if (tableContainer) {
            let width = tableContainer.offsetWidth - tableDiv.offsetWidth;
            if (tableContainer.scrollHeight !== tableContainer.offsetHeight) {
                width -= 18;
            }
            if (width < 1) {
                return;
            }
            let fixedColumnsCount = 0;
            this.settingsTable.userColumns.forEach((column) => {
                if (!column.is_fixed) {
                    fixedColumnsCount++;
                }
            });
            if (fixedColumnsCount > 0) {
                const widthAdd = width / fixedColumnsCount;

                const nameColumns = [];
                this.settingsTable.userColumns.forEach((column) => {
                    if (!column.is_fixed) {
                        column.width = parseFloat(String(column.width)) + widthAdd;
                        nameColumns.push(column.name);
                    }
                });
                this.settingsTable.userTree.select.forEach((column) => {
                    if (nameColumns.indexOf(this.getAliasColumn(column)) !== -1) {
                        column.width = parseFloat(column.width + '') + widthAdd;
                    }
                });
                this.dataMatTable.updateStickyColumnStyles();
            }
            this.#cdr.detectChanges();
        }
    }

    /**
     * Открытие диалога настроек таблицы
     */
    openSettingsDialog() {
        const dialogRef = this.dialog.open(SettingsTableDialogComponent, {
            disableClose: true,
            autoFocus: false,
            width: '80vw',
            height: '80vh',

            data: {
                title: this.appService.language_dictionary.system_settings_table_title,
                settings: this.settingsTable.userTree,
                tableService: this.tableService,
                dynamicFieldName: this.dynamicFieldName,
                dynamicSystemFields: this.dynamicSystemFields,
                dynamicFilter: this.dynamicFilter,
            },
        });
        dialogRef
            .keydownEvents()
            .pipe(takeUntil(this._destroy$))
            .subscribe((result) => {
                if (result.code === 'Escape') {
                    this.spinner.hide();
                    dialogRef.close({ save: false });
                }
            });
        dialogRef
            .afterClosed()
            .pipe(takeUntil(this._destroy$))
            .subscribe((result) => {
                if (result.save) {
                    let isMain = false;
                    const userColumns = [];

                    this.settingsTable.displayedColumns = ['select'];
                    if (this.dataPalette && this.dataPalette.length) {
                        this.dataPalette.forEach((palette, index) => {
                            if (this.settingsTable.displayedColumns[index] !== 'system_color_' + palette.index) {
                                this.settingsTable.displayedColumns.splice(index, 0, 'system_color_' + palette.index);
                            }
                        });
                    }
                    this.clearDisplayedColumns();
                    this.settingsTable.userTree = result.settings;
                    setTimeout(() => {
                        this.settingsTable.userTree.select.forEach((node) => {
                            const name = this.getAliasColumn(node);
                            if (node.is_main) {
                                isMain = true;
                            }
                            userColumns.push({
                                name,
                                title: node.name,
                                type: node.type,
                                is_main: node.is_main,
                                is_sticky: node.is_sticky,
                                width: !!node.width ? node.width : 100,
                                is_fixed: !!node.is_fixed,
                                is_group: node.columns.length !== 0,
                                transformParam: node?.transformParam,
                                cell: (row: any) => this.getCellRow(node, row) as string,
                            });
                            if (this.dynamicFilter) {
                                userColumns[userColumns.length - 1].id = node.id;
                                userColumns[userColumns.length - 1].name = name;
                                if (node.relation_id) {
                                    userColumns[userColumns.length - 1].relation_id = node.relation_id;
                                }
                            }
                            this.settingsTable.displayedColumns.push(name);
                        });
                        this.settingsTable.displayedColumns = this.#sortDisplayedColumns(
                            this.settingsTable.displayedColumns,
                        );
                        if (!isMain) {
                            userColumns[0].is_main = true;
                        }
                        // Если в фильтре остались колонки, которых больше нет, необходимо от них избавиться
                        Object.keys(this.filterRequest).forEach((key) => {
                            const transformKey = key.replace('|', '_');
                            if (userColumns.findIndex((row) => row?.name === transformKey) === -1) {
                                delete this.filterRequest[key];
                            }
                        });

                        this.settingsTable.userColumns = userColumns;

                        if (this.tableService) {
                            let settingData = Object.assign({}, this.settingsTable);
                            if (this.dynamicFilter) {
                                settingData = Object.assign(settingData, this.dynamicFilter);
                            }
                            if (this.tableModule) {
                                settingData.module = this.tableModule;
                            }

                            this.tableService
                                .saveTableSettings(settingData)
                                .toPromise()
                                .then(() => {
                                    this.getData(true);
                                });
                            setTimeout(() => {
                                this.setAutoWidth();
                            }, 100);
                        }
                    });
                } else if (result.saveCard) {
                    this.saveCard.emit({
                        isClearTableSettings: result.isClearTableSettings,
                        dynamicFilter: this.dynamicFilter,
                        tableService: this.tableService,
                    });
                }
            });
    }

    /**
     * Проставление функций для отрисовки
     */
    setCellForColumns() {
        this.settingsTable.userColumns.forEach((sort) => {
            this.settingsTable.userTree.select.forEach((node) => {
                if (sort.is_group && sort.name == this.getAliasColumn(node)) {
                    sort.cell = (row: any) => this.getCellRow(node, row) as string;
                } else if (
                    !sort.is_group &&
                    this.dynamicFilter &&
                    node.id == sort.id &&
                    node.relation_id == sort.relation_id
                ) {
                    node.alias = sort.name;
                    sort.cell = (row: any) => this.getCellRow(node, row) as string;
                }
                if (!sort.is_group && !this.dynamicFilter && sort.name == this.getAliasColumn(node)) {
                    sort.cell = (row: any) => this.getCellRow(node, row) as string;
                }
            });
        });
    }

    /**
     * Получение значения строки таблицы
     * @param node колонка
     * @param row строка
     * @param isString флаг возвращаемого значения
     */
    getCellRow(node: any, row: any, isString: boolean = true): string[] | string {
        let str = [];
        const strGroup = [];
        if (node.columns.length === 0) {
            if (row[node.alias] && typeof row[node.alias] === 'string' && node.type !== 'gallery') {
                row[node.alias] = this.replaceNewLine(row[node.alias]);
            }
            if (row[node.alias] && typeof row[node.alias] === 'object' && row[node.alias].length) {
                const result = [];
                row[node.alias].forEach((value) => {
                    if (value) {
                        result.push(value);
                    }
                });
                str = [result.join(', ')];
            } else if (node.type === 'reestr') {
                // Удалил глупости, matches это массив, row['linkfdi' + matches] не имеет смысла
                /// const matches = column.alias.match(/\d+/g);
                /// if (row['linkfdi' + matches]
                str.push(row[node.alias]);
            } else if (node.type === 'link' && row[node.alias] && typeof row[node.alias] !== 'string') {
                const url = row[node.alias].url;
                const urlName = row[node.alias]?.name !== '' ? row[node.alias]?.name : row[node.alias].url;
                str.push('<a href="/' + url + '" title="' + url + '/" target="_blank">' + urlName + '</a>');
            } else if (node.type === 'file' && row[node.alias]) {
                str.push(this.getFileCreate(row[node.alias], node.id));
            } else if (node.type === 'gallery' && row[node.alias]) {
                str.push('<div class="flex flex-wrap">' + this.getFileCreate(row[node.alias], node.id) + '</div>');
            } else if (node.type === 'color' && row[node.alias]) {
                str.push(this.getColorView(row[node.alias], node));
            } else {
                str.push(row[node.alias]);
            }
        } else {
            const groupColumn = {};
            let isGroupArray: boolean = false;
            node.columns.forEach((column) => {
                if (row[column.alias] && typeof row[column.alias] === 'string' && column.type !== 'gallery') {
                    row[column.alias] = this.replaceNewLine(row[column.alias]);
                }
                if (row[column.alias] && typeof row[column.alias] === 'object' && row[column.alias].length) {
                    isGroupArray = true;
                    row[column.alias].forEach((value, key) => {
                        if (value) {
                            if (typeof groupColumn[key] === 'undefined') {
                                groupColumn[key] = [];
                            }
                            groupColumn[key].push(value);
                        }
                    });
                } else if (column.type === 'reestr') {
                    // Удалил глупости, matches это массив, row['linkfdi' + matches] не имеет смысла
                    /// const matches = column.alias.match(/\d+/g);
                    /// if (row['linkfdi' + matches]
                    str.push(row[column.alias]);
                } else if (column.type === 'link' && row[column.alias] && typeof row[column.alias] !== 'string') {
                    const url = row[column.alias]?.url;
                    const urlName = row[column.alias]?.name ?? row[column.alias].url;
                    str.push('<a href="/' + url + '/" title="' + url + '" target="_blank">' + urlName + '</a>');
                } else if (column.type === 'file' && row[column.alias]) {
                    str.push(this.getFileCreate(row[column.alias], column.id));
                } else if (column.type === 'gallery' && row[column.alias]) {
                    str.push(this.getFileCreate(row[column.alias], column.id));
                } else if (column.type === 'color' && row[column.alias]) {
                    str.push(this.getColorView(row[column.alias], column));
                } else if (column.type === 'date' && row[column.alias]) {
                    str.push(this.#formatter.transform(row[column.alias], 'date'));
                } else if (column.type === 'datetime' && row[column.alias]) {
                    str.push(this.#formatter.transform(row[column.alias], 'datetime'));
                } else {
                    if (['boolean', 'bool'].includes(column.type)) {
                        str.push(this.#formatter.transform(row[column.alias], 'bool'));
                    } else {
                        str.push(row[column.alias]);
                    }
                }
            });
            if (isGroupArray) {
                for (const i in groupColumn) {
                    if (groupColumn.hasOwnProperty(i) && groupColumn[i] && groupColumn[i].length) {
                        strGroup.push(groupColumn[i].join(' '));
                    }
                }
            }
        }
        if (isString) {
            return strGroup.length ? strGroup.join(', ') : str.join(' ');
        } else {
            return strGroup.length ? strGroup : str;
        }
    }

    /**
     * Получение алиаса колонки
     * @param node: {TreeNode} node ветка дерева колонок
     */
    getAliasColumn(node: TreeNode): string {
        let name = '';
        if (node.columns.length == 0) {
            name = node.alias;
        } else {
            const str = [];
            node.columns.forEach((alias) => str.push(alias.alias));
            name = str.join('_');
        }
        return name;
    }

    /**
     * Создание нового фильтра
     */
    createFilter(data) {
        if (!data) {
            return;
        }

        if (this.dynamicFilter) {
            data = Object.assign(data, this.dynamicFilter);
        }
        this.spinner.show(this.spinnerName);

        this.filterService
            .copyItem(data)
            .toPromise()
            .then((result: IAppRequest) => {
                this.spinner.hide(this.spinnerName);

                if (result && result.is_error == false) {
                    if (this.isLocalFilter) {
                        this.extendFilterRecordsModel.push(result.data);
                        this.extendFilterIdModel = result.data.id;
                        this.setActiveFilter(this.extendFilterIdModel);
                    } else {
                        this.formFilter.savedSerchesService.filterRecords$.pipe(take(1)).subscribe((list) => {
                            list.push(result.data);
                            this.formFilter.savedSerchesService.filterRecords = list;
                        });

                        this.formFilter.savedSerchesService.selectedFilterId = result.data.id;
                    }
                    this.notifier.notify('success', this.appService.language_dictionary.system_data_successfully_saved);
                } else {
                    this.notifier.notify('error', result.message);
                }
            })
            .catch(() => {
                this.spinner.hide(this.spinnerName);
                this.notifier.notify('error', this.appService.language_dictionary.system_no_connection_with_system);
            });
    }

    /**
     * Сохранение фильтра
     */
    saveFilter() {
        if (this.selectFilter) {
            this.router.navigate(['designer-filter', this.selectFilter.id ? this.selectFilter.id : 0]);
        }
    }

    /**
     * Выбор активного фильтра
     * @param id ид фильтра
     */
    setActiveFilter(id: string) {
        /* Переводим пользователя на первую страницу таблицы */
        this.settingsTable.userIndex = 1;
        const localFilter = this.token.getFilterTable(this.getTableKey('FilterTable'));
        this.form = this.formBuilder.group({});
        if (this.isLocalFilter) {
            this.extendFilterRecordsModel.forEach((record) => {
                if (record.id == id) {
                    this.selectFilter = Object.assign({}, record);
                }
            });
        } else {
            this.formFilter.savedSerchesService.filterRecords$.pipe(take(1)).subscribe((list) => {
                list.forEach((record) => {
                    if (record.id == id) {
                        this.selectFilter = Object.assign({}, record);
                    }
                });
            });
        }
        if (this.selectFilter && this.settingsTable.filterId != this.selectFilter.id) {
            this.settingsTable.filterId = this.selectFilter.id;
            if (this.tableService) {
                let settingData = Object.assign({}, this.settingsTable);
                if (this.dynamicFilter) {
                    settingData = Object.assign(settingData, this.dynamicFilter);
                }
                if (this.tableModule) {
                    settingData.module = this.tableModule;
                }
                this.tableService.saveTableSettings(settingData).toPromise();
            }
        }
        if (this.isFirstLoadFilter && this.selectFilter && localFilter) {
            this.selectFilter.query = localFilter;
            this.extendFilter = localFilter;
            this.isFirstLoadFilter = false;
            this.getData(true);

            const showFilter = this.isFilterSet();
            this.formFilter.isFilterSet = showFilter;
            this.formFilter.isOpenFilter = showFilter;
        } else if (this.selectFilter && (this.selectFilter.query || this.settingsTable.filterId)) {
            this.extendFilter = this.selectFilter.query;
            this.getData(true);
            this.token.saveFilterTable(this.getTableKey('FilterTable'), this.extendFilter);
            this.formFilter.isOpenFilter = false;
            this.formFilter.isFilterSet = this.isFilterSet();
        }
    }

    /**
     * Открытие диалога сохранения фильтра
     */
    openFilterDialog(): void {
        const dialogRef = this.dialog.open(FilterDialogsComponent, {
            disableClose: true,
            autoFocus: false,
            width: '600px',
            data: {
                title: this.appService.language_dictionary.system_add,
            },
        });
        dialogRef
            .keydownEvents()
            .pipe(takeUntil(this._destroy$))
            .subscribe((result) => {
                if (result.code === 'Escape') {
                    dialogRef.close({ save: false });
                }
            });
        dialogRef
            .afterClosed()
            .pipe(takeUntil(this._destroy$))
            .subscribe((result) => {
                if (result.save) {
                    const data = {
                        id: this.selectFilter.id,
                        name: result.title,
                        query: this.form.value,
                    };
                    this.createFilter(data);
                }
            });
    }

    /**
     * Проверка пустоты фильтров
     */
    isEmptyFilter(): boolean {
        if (this.globalFilter) {
            return false;
        }

        if (!this.isEmptyData(this.extendFilter)) {
            return false;
        }
        if (!this.isEmptyData(this.filterRequest)) {
            return false;
        }
        return true;
    }

    /**
     * Проверка наличия данных в объекте фильтра
     * @param data данные фильтра
     */
    isEmptyData(data: any): boolean {
        let isEmpty = true;

        for (const val in Object.values(data)) {
            switch (typeof val) {
                case 'object':
                    if (val === null) {
                        break;
                    }
                    isEmpty = this.isEmptyData(val);
                    break;
                case 'boolean':
                    isEmpty = false;
                    break;
                default:
                    isEmpty = !Boolean(val);
            }
            if (!isEmpty) {
                return isEmpty;
            }
        }
        return isEmpty;
    }

    /**
     * Добавление слоя
     */
    openAddLayer(): void {
        const dialogRef = this.dialog.open(TableLayerDialogComponent, {
            disableClose: true,
            autoFocus: false,
            width: '800px',
            data: {
                tableService: this.tableService,
                query: this.extendFilter,
                dynamicFilter: this.dynamicFilter,
                title: this.appService.language_dictionary.system_layer_dialog_title_add,
                id: this.isLocalFilter
                    ? this.extendFilterIdModel
                    : this.formFilter.savedSerchesService.selectedFilterId,
            },
        });
        dialogRef
            .keydownEvents()
            .pipe(takeUntil(this._destroy$))
            .subscribe((result) => {
                if (result.code === 'Escape') {
                    dialogRef.close({ save: false });
                }
            });
        dialogRef
            .afterClosed()
            .pipe(takeUntil(this._destroy$))
            .subscribe((result) => {
                if (result.save) {
                    this.notifier.notify('success', this.appService.language_dictionary.system_data_successfully_saved);
                }
            });
    }

    /** Формирование данных для дерева */
    public groupByTree(): void {
        this.dataTables.filteredData = this.addGroupsTree(this.dataTables.filteredData);
        this.filteredDataTreeAll = this.dataTables.filteredData.slice();
    }

    /**
     * Генерация данных для дерева
     * @param data данные дерева
     * @param parent_id ид родительской записи
     * @param level уровень ветки в дереве
     * @return TreeNodeRegister[]
     */
    generateTreeData(data: any[], parent_id: string | number, level: number): any[] {
        const result: any[] = [];
        data.forEach((value) => {
            if (value.parent_id == parent_id) {
                const node: any = Object.assign({}, value);
                node.level = level;
                node.expanded = true;
                node.children = this.generateTreeData(data, node.id, level + 1);
                node.is_children = node.children.length != 0;
                result.push(node);
            }
        });
        return result;
    }

    /**
     * Генерация массива для дерева
     * @param data данные таблицы
     * @param parent родительская запись
     */
    generateArrayTree(data: any[], parent: any) {
        let result: any[] = [];
        data.forEach((value) => {
            const node = Object.assign({}, value);
            delete node.children;
            node.parent = parent;
            result.push(node);
            if (value.is_children) {
                result = result.concat(this.generateArrayTree(value.children, node));
            }
        });
        return result;
    }

    /**
     * Нажатие на строку
     * @param row строка
     */
    groupHeaderTreeClick(row: any) {
        row.expanded = !row.expanded;
        const data = [];
        this.filteredDataTreeAll.forEach((value) => {
            if (!value?.parent || (value?.parent && this.isExpandedParents(value?.parent))) {
                data.push(value);
            }
        });
        this.dataTables.filteredData = data;
    }

    /**
     * Проверка отображения строк
     * @param parent родительская запись
     */
    isExpandedParents(parent: any) {
        let expanded = parent.expanded;
        if (expanded && parent.parent) {
            expanded = this.isExpandedParents(parent.parent);
        }
        return expanded;
    }

    /**
     * Формирование данных для таблицы древовидной формы
     * @param data
     */
    addGroupsTree(data: any[]): any[] {
        const tree = this.generateTreeData(data, this.groupByTreeColumns.rootId, 1);
        return this.generateArrayTree(tree, null);
    }

    /**
     * Инициализация формы редактирование строк в таблице
     */
    initFormEdit() {
        this.formEdit = this.formBuilder.group({});
        this.dataTables.filteredData.forEach((row: any) => {
            Object.keys(this.settingsEditFields.fields).forEach((field) => {
                const formGroup = this.formBuilder.group({});
                this.formEdit.addControl(field + '_' + row?.id, formGroup);
                formGroup.addControl('value', this.formBuilder.control(row[field] ? row[field] : null, []));
                formGroup.addControl('id', this.formBuilder.control(row?.id ? row.id : null, []));
                formGroup.addControl('field', this.formBuilder.control(field, []));
            });
        });
        for (const control in this.formEdit.controls) {
            if (this.formEdit.controls.hasOwnProperty(control)) {
                this.formEdit
                    .get(control)
                    .valueChanges.pipe(debounceTime(this.appService.timeSave))
                    .subscribe((value) => this.onFieldChange.next(value));
            }
        }
    }

    /**
     * Получение структуры файлов
     * @param rowElement строка с данными
     * @param id - ID поля
     */
    getFileCreate(rowElement: string | object, id: string) {
        if (!rowElement) {
            return '';
        }
        let valueArray = [];
        const result = [];
        if (typeof rowElement === 'object') {
            valueArray = Object.entries(rowElement);
        } else {
            try {
                valueArray = JSON.parse(rowElement);
            } catch (e) {
                valueArray = rowElement.split('{br}');
            }
        }
        if (valueArray.length > 0 && typeof rowElement === 'object') {
            valueArray.forEach(([key, val]) => {
                if (val && key) {
                    const data = {
                        val,
                        key,
                        id,
                    };
                    const structFile = this.prepareFileStruct(data);
                    result.push(structFile);
                }
            });
        } else {
            valueArray.forEach((val) => {
                result.push(this.prepareFileStruct({ val, id }));
            });
        }
        return result.join(' ');
    }

    /**
     * Подготовка структуры файлов
     * @param data InterfaceTableFileStruct
     */
    prepareFileStruct(data: InterfaceTableFileStruct): string {
        const url = this.appService.settings.system_back_url + data.val.file_name;
        const urlExt = this.appService.serverUrl + data.val.file_name_ext;
        const urlExtPreview = this.appService.serverUrl + data.val.file_name_ext + '&p=1';
        let image = '';
        if (this.isImageFromExtension(url)) {
            image = '<img src="' + urlExtPreview + '" alt="">';
        } else {
            if (
                this.settingsTable?.settings_nodes &&
                this.settingsTable?.settings_nodes[data.id] &&
                this.settingsTable?.settings_nodes[data.id].pdf_preview == '1' &&
                this.getExtension(url).toLowerCase() === 'pdf'
            ) {
                image = '<img src="' + urlExtPreview + '" alt="">';
            } else {
                image =
                    '<svg version="1.1" xmlns="http://www.w3.org/2000/svg"' +
                    '     x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve">' +
                    '    <path style="fill:#E2E5E7;"' +
                    '          d="M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"/>' +
                    '    <path style="fill:#B0B7BD;" d="M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"/>' +
                    '    <polygon style="fill:#CAD1D8;" points="480,224 384,128 480,128 "/>' +
                    '    <path class="color-document-svg"' +
                    '          d="M416,416c0,8.8-7.2,16-16,16H48c-8.8,' +
                    '0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"/>' +
                    '    <text' +
                    '        style="font-size: 114px;text-align: center;font-weight: bold;fill:#ffffff;text-transform: uppercase;"' +
                    '        x="65" y="375">' +
                    this.getExtension(url) +
                    '    </text>' +
                    '    <path style="fill:#CAD1D8;"' +
                    '          d="M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"/>' +
                    '</svg>';
            }
        }
        let elem =
            '<div class="table-file-cell">' +
            '<a href="' +
            urlExt +
            '" class="image-preview-container' +
            (this.getExtension(url).toLowerCase() === 'pdf' ? ' pdf-preview-frame' : '') +
            '" target="_blank" title="' +
            data.val.name +
            '">' +
            image +
            '</a>';
        // Добавляем отображение данных файла
        if (this.settingsTable?.settings_nodes != null) {
            if (
                this.settingsTable?.settings_nodes[data.id] &&
                Number(this.settingsTable?.settings_nodes[data.id].is_show_file_info) === 1
            ) {
                elem += '<div class="file-info">';
                if (data.val?.name) {
                    elem += '<div>' + data.val.name + '</div> ';
                }
                if (data?.val?.size && Number(data.val.size) > 0) {
                    elem +=
                        '<div>' +
                        AppHelper.calcFileSize(data.val.size, 'Mb', 2) +
                        ' ' +
                        this.appService.language_dictionary.files_mb +
                        '</div> ';
                }
                if (data?.val?.download_date) {
                    elem += '<div>' + getDateTimeRuFormat(data.val.download_date) + '</div> ';
                }
                elem += '</div>';
            }
        } else {
            if (data.val?.name) {
                elem += '<div class="file-name">' + data.val.name + '</div>';
            }
        }
        elem += '</div>';
        return elem;
    }

    /**
     * Проверка картинка или нет файл из расширения
     */
    isImageFromExtension(file) {
        let ext = file.split('.');
        ext = ext[ext.length - 1];
        if (!ext) {
            return false;
        }
        ext = ext.toLowerCase();
        return IMG_EXTENSIONS.indexOf(ext) > -1;
    }

    /**
     * Получение расширения файла
     */
    getExtension(name) {
        return name ? name.slice(((name.lastIndexOf('.') - 1) >>> 0) + 2) : null;
    }

    /**
     * Получение ссылку на файл без расширения
     */
    getUrlWithoutExt(name) {
        return name ? name.slice(0, name.lastIndexOf('.')) : null;
    }

    /**
     * Замена переноса строк
     * @param row значение строки
     */
    replaceNewLine(row) {
        if (row && typeof row == 'string') {
            row = row.replace(/{br}/g, ', ');
        }
        return row;
    }

    /**
     * Удаление списка записей
     * @param selected выбранные записи
     */
    removeRecords(selected: any[]) {
        const ids = [];
        selected.forEach((value) => ids.push(value.id));
        this.dialogConfirm
            .confirm(
                this.appService.language_dictionary.system_confirm_action,
                this.appService.language_dictionary.system_are_you_sure_want_delete,
            )
            .subscribe((res) => {
                if (res) {
                    this.spinner.show(this.spinnerName);
                    this.tableService
                        .remove({ id: ids })
                        .toPromise()
                        .then((result: IAppRequest) => {
                            this.spinner.hide(this.spinnerName);
                            if (result && result.is_error === false) {
                                this.notifier.notify(
                                    'success',
                                    this.appService.language_dictionary.system_data_successfully_deleted,
                                );
                                this.getData(true);
                            } else {
                                this.notifier.notify('error', result.message);
                            }
                        })
                        .catch(() => {
                            this.spinner.hide(this.spinnerName);
                            this.notifier.notify(
                                'error',
                                this.appService.language_dictionary.system_no_connection_with_system,
                            );
                        });
                }
            });
    }

    /**
     * Получение сортировки для отправки в запросе
     * @param userSort текущая сортировка
     */
    private getSortParam(userSort: { name: string; sort: CustomSortDirection }[]) {
        const sortResult = [];
        if (userSort) {
            userSort.forEach((sort) => {
                this.settingsTable.userTree.select.forEach((node) => {
                    if (sort.name == this.getAliasColumn(node)) {
                        if (node.columns.length == 0) {
                            sortResult.push(sort);
                        } else {
                            node.columns.forEach((alias) =>
                                sortResult.push({
                                    name: alias.alias,
                                    sort: sort.sort,
                                }),
                            );
                        }
                    }
                });
            });
        }
        return sortResult;
    }

    /**
     * Получение основной палитры
     */
    getMainPalette(palette: any) {
        for (const key in palette) {
            if (palette[key].main) {
                this.mainPalette = 'color_' + palette[key].index;
            }
        }
    }

    /**
     * Отслеживаем события нажатия на Enter
     */
    @HostListener('document:keypress', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        if (event.code === 'Enter' && this.formFilter.isOpenFilter) {
            this.formFilter.isOpenFilter = false;
            this.setExtendFilter();
        }
    }
    @HostListener('document:keydown', ['$event'])
    handleKeyboardEventTwo(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            this.#turnFullScreenOff();
        }
    }

    /** Плавное отображение хедера таблицы при наведении на панель инструментов таблицы */
    @HostListener('mouseover', ['$event'])
    onMouseEnter(event: MouseEvent) {
        if (this.isFullScreenMode && this.tablePanel?.nativeElement?.contains(event.target as Node)) {
            this.tableHeader?.nativeElement.classList.add('show');
        }
        if (this.matTable && this.matTable?.nativeElement?.contains(event.target as Node)) {
            this.tableHeader?.nativeElement.classList.remove('show');
        }
    }

    /**
     * Получить выравнивание в ячейке
     * @param column - колонка
     */
    getAlign(column): string | boolean {
        if (column && column.type) {
            switch (column.type) {
                case 'float':
                case 'int':
                case 'integer':
                    return 'right';
                default:
                    return false;
            }
        }
        return false;
    }

    /**
     * Добавить сквозную нумерацию в таблицу
     */
    getTablePagination(): number {
        if (this.settingsTable.userIndex != 1) {
            return this.settingsTable.userSize * (this.settingsTable.userIndex - 1);
        }
        return 0;
    }

    /**
     * Проверка активности кнопки
     * @param disable условия деактивации кнопки
     * @param element текущая строка таблицы InterfaceTableElement
     */
    getDisableStat(disable: { field: string; condition: string }, element: InterfaceTableElement) {
        if (element.hasOwnProperty('is_active')) {
            const active = element?.is_active;
            if (disable?.condition === '1') {
                return active ? true : false;
            }
            if (disable?.condition === '') {
                return !active;
            }
        }
        if (element?.file_count) {
            return element?.file_count > 0;
        } else {
            return element[disable?.field] == disable.condition;
        }
    }

    /**
     * Получение цвета для типа поля палитра
     * @param rowElement - элемент ячейки
     * @param node - параметры колонки
     */
    getColorView(rowElement: string, node: any): string {
        return (
            '<div style="display: flex; align-items: center; margin-top: 5px "> <div class="color-container" style="background-color:#' +
            rowElement.replace('#', '') +
            '"></div>' +
            ' ' +
            rowElement +
            '</div>'
        );
    }

    /**
     * Проверка того, нужно ли задизаблить кнопку
     * @param button кнопка, для которой проводится проверка
     */
    isDisabledButton(button: IButton): boolean {
        if (button.records === 'one' && this.selection.selected.length !== 1) {
            return true;
        }

        if (button.records === 'many' && this.selection.selected.length === 0) {
            return true;
        }

        if (typeof button.disabled === 'boolean') {
            return button.disabled;
        }

        if (typeof button.disabled === 'function') {
            return button.disabled(this.selection.selected);
        }

        if (typeof button.disabled === 'object') {
            return (
                button.records === 'one' &&
                this.selection.selected.length === 1 &&
                this.selection.selected[0][button?.disabled?.field] === button?.disabled?.condition
            );
        }

        return false;
    }

    /**
     * Увеличиваем счетчик построенных элементов
     * @module report_constructor
     */
    increaseCount(): void {
        if (this.tableService?.exportReady$) {
            // В момент построения отчета изменяем количество готовых элементов
            const num = this.tableService.exportReady$.value + 1;
            this.tableService.exportReady$.next(num);
        }
    }

    public setPanelClass(matSelect: MatSelect) {
        if (matSelect._overlayPanelClass.indexOf('custom-select-panel') === -1) {
            matSelect._overlayPanelClass += 'custom-select-panel';
        }
        return '';
    }

    /**
     * Обнаружить изменения
     */
    public detectChanges() {
        this.#cdr.detectChanges();
    }

    /** Переключить видимость строки фильтров таблицы */
    public toggleTableFilter() {
        if (Object.keys(this.filterTable).length) {
            this.filterTable = {};
            this.changeFilter();
        }
        this.settingsTable.isColumnFilter = !this.isColumnFilter;
        this.tableService.saveTableSettings(Object.assign(this.settingsTable)).toPromise();
    }

    /**
     * Определяет порядок displayedColumns в таблице.
     * Порядок - fixedOrder, systemColorColumns, все остальное
     * @param string[] displayedColumns
     * @private
     */
    #sortDisplayedColumns(displayedColumns: string[]): string[] {
        // Столбцы которые всегда есть
        const fixedOrder = TABLE_FIXED_COLUMS;
        // Столбцы палитры
        const systemColorColumns = displayedColumns.filter((col) => col.startsWith('system_color_'));

        const columns = [...fixedOrder, ...systemColorColumns];

        // Все остальные столбцы
        const unknownColumns = displayedColumns.filter((col) => !columns.includes(col));

        return [...columns, ...unknownColumns];
    }

    /**
     * Устанавливает сортировку по-умолчанию в таблице
     * @private
     */
    #setDefaultSort() {
        const { userSort, userColumns } = this.settingsTable;

        if (!userSort?.length && userColumns?.length) {
            this.settingsTable.userSort = [
                {
                    name: userColumns[0].name,
                    sort: 'asc',
                },
            ];
        }
    }

    /**
     * Обработчик для выделения по нажатию shift
     */
    selectionKeyboardHandler() {
        let isSelectingRange = false;
        let rangeToSelect = [];

        this.selection.changed.pipe(takeUntil(this._destroy$)).subscribe(() => {
            if (isSelectingRange) {
                return;
            }

            if (this.shiftKeyPressed$.getValue()) {
                const selectedItems = this.selection.selected;
                if (selectedItems.length > 0) {
                    const firstSelectedItem = selectedItems[0];
                    const lastSelectedItem = selectedItems[selectedItems.length - 1];

                    const filteredData = this.dataTables.filteredData;
                    let firstIndex = filteredData.findIndex((item) => item === firstSelectedItem);
                    let lastIndex = filteredData.findIndex((item) => item === lastSelectedItem);

                    if (firstIndex > lastIndex) {
                        const temp = firstIndex;
                        firstIndex = lastIndex;
                        lastIndex = temp;
                    }

                    if (firstIndex !== -1 && lastIndex !== -1) {
                        rangeToSelect = filteredData.slice(firstIndex, lastIndex + 1);
                    }
                }

                if (rangeToSelect?.length) {
                    isSelectingRange = true;
                    rangeToSelect.forEach((item) => this.selection.select(item));
                    isSelectingRange = false;
                }
            }
        });
    }

    @HostListener('window:keydown.shift', ['$event'])
    handleShiftDown() {
        if (!this.shiftKeyPressed$.getValue()) {
            this.shiftKeyPressed$.next(true);
        }
    }

    @HostListener('window:keyup.shift', ['$event'])
    handleShiftUp() {
        if (this.shiftKeyPressed$.getValue()) {
            this.shiftKeyPressed$.next(false);
        }
    }

    /**
     * Проверка есть ли что-то выбраное в расширенном фильтре
     * (local storage)
     */
    isFilterSet(): boolean {
        const localFilter = this.token.getFilterTable(this.getTableKey('FilterTable'));

        const hasNonNullValue = (obj: any): boolean => {
            if (obj === null || obj === undefined) {
                return false;
            }

            if (typeof obj === 'object') {
                return Object.values(obj).some((innerVal) => {
                    if (innerVal === null || innerVal === undefined) {
                        return false;
                    }
                    return hasNonNullValue(innerVal);
                });
            }

            return true;
        };

        return Object.values(localFilter).some((val) => hasNonNullValue(val));
    }

    /**
     * Открыть/закрыть фильтр
     */
    toggleFilter() {
        this.formFilter.isOpenFilter = !this.formFilter.isOpenFilter;
    }

    /**
     * Свернуть/развернуть контент таблицы
     */
    toggleContent(): boolean {
        const value = !this.showTableContent$.value;
        this.showTableContent$.next(value);
        return value;
    }

    /**
     * Правый клик мыши по строке (отображение меню)
     */
    onRightClick(event: MouseEvent, row): void {
        event.preventDefault();
        this.selection.select(row);
        this.tableHeaderComponent?.openContextMenu(event);
    }

    /**
     * Выход из полноэкранного режима
     */
    #turnFullScreenOff() {
        this.isFullScreenMode = false;
        this.appService.showSideMenu.next(true);
        this.adjustButtons();
        if (this.tableHeader) {
            this.tableHeader.nativeElement.classList.remove('show');
        }
    }
}
